import { liveDocIcon } from "@memo-air/react";
import { LiveDocActivity } from "@app/components/live/LiveDocActivity";
import { useLiveDocActivity } from "@app/lib/swr/live_activity";
import type { LiveDocType } from "@app/types/live_docs";
import type { LightWorkspaceType } from "@app/types/user";
import { Icon } from "@dust-tt/sparkle";

interface LiveDocsGroupProps {
  owner: LightWorkspaceType;
  conversationId?: string;
  onOpen: (doc: LiveDocType) => void;
}

export function LiveDocsGroup({
  owner,
  conversationId,
  onOpen,
}: LiveDocsGroupProps) {
  const { liveDocs, summaries } = useLiveDocActivity({ owner });
  const docs = conversationId
    ? liveDocs.filter((doc) => doc.conversationId === conversationId)
    : liveDocs;

  if (docs.length === 0) {
    return null;
  }

  return (
    <section className="flex flex-col gap-1 px-2 py-2" aria-label="Live docs">
      <h3 className="px-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground dark:text-muted-foreground-night">
        Live
      </h3>
      {docs.map((doc) => (
        <button
          key={doc.sId}
          type="button"
          onClick={() => onOpen(doc)}
          className="flex items-center gap-3 rounded-lg px-2 py-2 text-left hover:bg-muted-background dark:hover:bg-muted-background-night"
        >
          <Icon visual={liveDocIcon(doc.kind)} size="sm" />
          <span className="min-w-0 flex-1 truncate text-sm text-foreground dark:text-foreground-night">
            {doc.title}
          </span>
          <span className="max-w-[55%] shrink-0">
            <LiveDocActivity
              summary={summaries[doc.sId]}
              fallbackEditedAt={doc.updatedAt}
            />
          </span>
        </button>
      ))}
    </section>
  );
}
